export const powerBiConstants = {
  ihxFinanceProvider: {
    PBI_DASHBOARD_TYPE: 'IHX_Finance_Provider',
    FINANCE: 'Finance',
    REPORT: 'report',
    filter: {
      $schema: 'http://powerbi.com/product/schema#advanced',
      target: {
        table: 'Hospital Claim Data',
        column: 'MaMasterId',
      },
      operator: 'In',
      values: [] as any,
    },
  },
};

export const powerBiConstantsDash = {
  ihxFinanceProvider: {
    PBI_DASHBOARD_TYPE: 'MetricBoard_IHX',
    FINANCE: 'Finance',
    REPORT: 'report',
    filter: {
      $schema: 'http://powerbi.com/product/schema#advanced',
      target: {
        table: 'Claim Data',
        column: 'IHXHospitalID',
      },
      operator: 'In',
      values: [] as any,
    },
  },
};

export const powerBiConstantsDash1 = {
  ihxFinanceProvider: {
    PBI_DASHBOARD_TYPE: 'MetricBoard_IHX',
    FINANCE: 'Finance',
    REPORT: 'report',
    filter: {
      $schema: 'http://powerbi.com/product/schema#advanced',
      target: {
        table: 'Claim Data',
        column: 'Payer Name',
      },
      operator: 'In',
      values: [] as any,
    },
  },
};
